import JSONAPIClient from '../JSONAPIClient'

JSONAPIClient.define('connection', {
  task_id: '',
  connect_url: '',
  customer_institution_login_id: '',
})
